<template>
    <div class="modal fade" id="unerlaubtModal" tabindex="-1" role="dialog" aria-labelledby="unerlaubtModalTitle" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="unerlaubtModalTitle">Fachmann notwendig!</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <p class="content-absatz"> 1. Standorthöhe von über 1.100m </p>
            <p class="content-absatz"> 2. Exponierte Lage </p>
            <p class="content-absatz"> 3. Keine Deckunterlage </p>
            <p class="content-absatz"> 4. Keine geschlossene Deckunterlage + Nicht geschlossenes Gebäude </p>
            <p class="content-absatz"> Sollte eine dieser Angaben zutreffen liegt die Berechnung außerhalb der Möglichkeiten dieses Rechners
            Kontaktieren Sie einen Sonderfachmann. Gerne unterstützen wir Sie hierbei.</p>
        </div>
        </div>
    </div>
    </div>
</template>


<script>

export default {
  name: 'UnerlaubtModal',
  props: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>